var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_apple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2971 22.5583C17.0178 23.7985 15.6209 23.6027 14.2763 23.0152C12.8534 22.4147 11.5479 22.3886 10.0466 23.0152C8.16675 23.8246 7.1746 23.5896 6.05191 22.5583C-0.318731 15.9919 0.621199 5.99206 7.85344 5.62653C9.61581 5.71791 10.8429 6.59257 11.8743 6.6709C13.4147 6.35759 14.8899 5.45682 16.5347 5.57431C18.506 5.73097 19.9942 6.51424 20.9733 7.92414C16.9003 10.3653 17.8663 15.7308 21.5999 17.2321C20.8558 19.1903 19.8898 21.1354 18.2841 22.5714L18.2971 22.5583ZM11.7437 5.5482C11.5479 2.63703 13.9108 0.234983 16.6261 0C17.0047 3.36808 13.5714 5.87457 11.7437 5.5482Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApple);
export default __webpack_public_path__ + "static/media/ic_apple.b76dbf3b8852fab278726daafd900c59.svg";
export { ForwardRef as ReactComponent };